import { render, staticRenderFns } from "./SegmentResultList.vue?vue&type=template&id=a30fb5b8&scoped=true"
import script from "./SegmentResultList.vue?vue&type=script&lang=js"
export * from "./SegmentResultList.vue?vue&type=script&lang=js"
import style0 from "./SegmentResultList.vue?vue&type=style&index=0&id=a30fb5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30fb5b8",
  null
  
)

export default component.exports